var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([1bhjpu]|q[eik]|4p|a2g|ef|ft|hm|j3|ot)|n([79bdilqw]|1g|23|2u|4y|57|95|c5|j1|jx|ya|ze)|2([278]|57|5k|7y|ci|d6|g3|hd|ho|k4|s3)|f([24enorvw]|bm|d3|l3|m4|n7|ob|rd|sl|to|wi|wn|zs)|q([14w]|g9e|j7|k4|mc|v0|x6)|w([067v]|1v|57|a6|cf|fe|gz|ju|ry|wb)|z([bmwz]|0x|51|a9|dw|f4|gc|mu|t1|x5|zw)|o([348fhw]|u[3hz]|15|4n|8t|dj|fo|xn|za|zc)|k(1f|1z|3|4h|89|iq|m|q9|r2|xk|ya|zb)|d([2ckz]|30|f6|gb|i0|nc|pi|v7)|l([bclu]|4t|b0|dd|h5|iy|w0|ym)|7([7apwz]|2a|2d|5z|86|a2|fa|gn|hg|ie|j1|uw)|b([236jloz]||kn|sc|t4|vx|w0|w7|xt)|9([3jloqy]|65|87|am|gn|j2|mq|p9|q6)|r(02|7a|9|g|hk|j8|n6|oo|q7|xd|zx)|0([04dgjmx]|1[5kq]|92|ag|aj|bc|ig|q9|tf|vb|wl|xz|yz)|t([6acnq]|l(3|7|lv)|0i|3w|51|7lm|ah|b7|gm|ii|n9|sa|ue)|i([1cikuw]|4i|4w|5f|99|a2|ap|b6|kr|lw|ns|r4|rz)|x([jlnyz]|[29h]y|4x|bv|gd|l7|mx|rh|yc|zc)|h([17uxy]|q3(|s)|4b|a5|ao|cx|g2|j6|kw|t8|wz)|j([45jptv]|29|a4|dp|i7|jd|wb|wf)|3(71|92|fl|j3|r4|wj|zr)|s([3bhkz]|[hmn]e|0a|61|6d|a8|c1|d9|ex|hs|kd|kj|lp|tz|vp)|v([9kqu]|b3|ct|fa|kh|kn|n4|og|y0)|1([137fiow]|00|8m|8w|f1|i1|iz|jf|mh|mu|rv|x7)|8([2dh]|1s|dm|e8|es|gu|hi|k2|my|nm|ov|qc|w4|xc)|g([19sw]|2n|mb|xu|yb|yf|zt)|p(2k|3|6o|ds|n8|ot|r|s4|yvv)|4([hknv]|17|1h|76|7e|eg|ft|uu|v5|wv)|a(2r|3u|7h|7y|9o|ck|cv|do|eb|f|ik|k3|rf|wv)|5([49kmnr]|0s|1p|4c|6n|6p|9x|kk|s9)|c([24cj]|n[9dq]|5s|8a|kc|mi)|6([3egqy]|19|3t|8y|96|cd|co|f0|fq|v8|vy)|u([38dlp]|1s|2l|gm|hn|u8|w8|wq)|e([59flrs]|w[cow]|2b|2f|ah|av|hk|mz|tk3|vi|vw)|y([8fkny]|2q|7n|ek|ji|l8))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
